var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00003 8.8667H3.33337M12.6667 8.8667H14M4.70017 12.1666L3.7575 13.1092C1.41417 10.7659 1.41417 6.9675 3.7575 4.62417M11.3002 5.5669L12.2428 4.62423M12.2428 4.62423C9.8995 2.2809 6.10017 2.28083 3.7575 4.62417M12.2428 4.62423C14.5862 6.96757 14.5862 10.7658 12.2428 13.1092L11.3002 12.1665M3.7575 4.62417L4.70017 5.56683M8.00003 2.8667V4.20003M10.2429 6.62417L8.47157 8.3955M8.6667 8.8667C8.6667 8.4987 8.3687 8.20003 8.00003 8.20003C7.63137 8.20003 7.33337 8.4987 7.33337 8.8667C7.33337 9.2347 7.63137 9.53337 8.00003 9.53337C8.3687 9.53337 8.6667 9.2347 8.6667 8.8667Z",
    stroke: "#CC1010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedIconRed);
export default __webpack_public_path__ + "static/media/speedIconRed.160ba67d769c8c59e4c10ca5b80b58f7.svg";
export { ForwardRef as ReactComponent };